package com.evoapps.evoshift.viewmodels

import com.evoapps.evoshift.domain.model.RosterPublishing
import com.evoapps.evoshift.domain.model.RosterStatus
import com.evoapps.evoshift.domain.model.Shift

/** SH-229: where the month stands, for the builder's Publish button. */
enum class RosterPublishState {
    /** Not published yet: "Publish". */
    DRAFT,
    /** Published, with shifts added or changed since: "Publish changes". */
    CHANGES,
    /** Published and nothing changed since: a quiet "Published". */
    PUBLISHED
}

/**
 * SH-229: a published (or locked) month has changes to publish while any of its [shifts] is not
 * published yet or was changed since ([Shift.hasUnpublishedChanges]); any other status is a draft.
 * SH-263: a published shift deleted since ([removed]) is a change too. The rule is
 * [RosterPublishing], shared with the banner, the list's badge and Start.
 */
fun rosterPublishState(
    status: RosterStatus?,
    shifts: Iterable<Shift>,
    removed: Collection<com.evoapps.evoshift.domain.model.RemovedShift> = emptyList()
): RosterPublishState = when {
    !RosterPublishing.wasPublished(status) -> RosterPublishState.DRAFT
    RosterPublishing.changes(status, shifts, removed) > 0 -> RosterPublishState.CHANGES
    else -> RosterPublishState.PUBLISHED
}
